<template>
  <div class="view open-view">
    <HeaderBar />
    <van-tabs class="dark" v-model="active" @change="onActiveChange" swipeable>
      <van-tab title="VIP会员">
        <div class="banner-wrap">
          <div class="banner">
            <div class="title">VIP会员</div>
            <div class="sub-title">尊享VIP会员多项专有权益，畅快学习、阅读</div>
            <div class="text--sub">尊享友绿独家付费内容超值折扣</div>
            <span class="price-text">{{ `￥${vipPrice}/年` }}</span>
          </div>
        </div>
        <div class="info-wrap">
          <div class="title">VIP会员专属权益</div>
          <img class="right-img" src="../../assets/images/vip_right2.png" />
          <img class="invite-img" src="../../assets/images/invite_banner.png" />
        </div>
        <footer class="footer">
          <van-button class="button" @click="openVip">{{ `￥${vipPrice}立即开通` }}</van-button>
        </footer>
      </van-tab>
      <van-tab title="企业服务">
        <div class="banner-wrap">
          <div class="banner" :class="{ green: active === 1 }">
            <!--<div class="title">企业服务</div>
            <div class="sub-title">尊享VIP会员多项专有权益，畅快学习、阅读</div>
            <div class="text--sub">尊享企业VIP专有定制服务</div>
            <span class="price-text">0/年</span>-->
            <div class='business-vip'>友绿为企业提供全球绿色科技研发应用的最新资讯、案例和市场洞察，定制行业发展趋势研究报告，开发绿色建筑、科技地产、清洁供热、能源规划及关联产业的培训课程，协助制定企业发展战略规划。</div>
          </div>
        </div>
        <!--<div class="info-wrap">
          <div class="title">VIP会员专属权益</div>
          <img class="right-img" src="../../assets/images/svip_right.jpg" />
                    <img class="invite-img" src="../../assets/images/invite_banner.png" />

        </div>
        <footer class="footer">
          <van-button class="button" @click="contactKF" :class="{ green: active === 1 }"
            >联系客服</van-button
          >
        </footer>-->
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Button, Tab, Tabs,Dialog} from 'vant';
import { Toast } from 'mint-ui'
import HeaderBar from '../../components/HeaderBar';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import { getUser ,setUser} from '../../utils/storageUtil';
import {isAndroid_Ios} from '../../utils/jsappUtil';

export default {
  name: 'open',
  components: {
    'van-button': Button,
    'van-tabs': Tabs,
    'van-tab': Tab,
    HeaderBar
  },
  data() {
    return {
      active: 0,
      vipPrice: '',
      user: null,
      vip_tag:'youLvVIP1998',
      is_vip:0,
    };
  },
  created() {
    this.init();
    this.user = getUser();
    this.getProfile();
    //ios返回的方法
    window.applePurchase = (response) => {
      this.appleVipPurchase(response)
    }
  },
  methods: {
    async init() {
      const res = await apiUtil.post(apiConst.getSuper);
      if (res.success) {
         this.vipPrice = res.price;
      }
    },

    async appleVipPurchase(response){
    var str=eval("(" + response + ")");
    let transaction_id =str.transaction_id,
        receipt_data =str.receipt_data,
        product_id =str.product_id;
        const res =await apiUtil.post(apiConst.appleVipPurchase, {
               receipt_data:receipt_data,
                product_id: product_id,
               transaction_id:transaction_id
          })
          if(res.success){
            Toast('支付成功');
            this.getProfile();
            let tag = this.user.jpush_status;
            window.HostApp.pushMsg(tag);
           }else{
              Toast('支付失败');
           }


      
    },
    async getProfile() {
      const res = await apiUtil.post(apiConst.getProfile);
      if (res.success) {
        const { integration ,is_vip} = res;
        this. is_vip = is_vip;
      }
    },
    onActiveChange(index, title) {},

    contactKF() {
      if(this.user && this.user.is_vip === 2){
        Toast({
          message: '您已经是企业VIP了',
          duration: 1000
        })
        return;
      }
      Dialog.confirm({
        title: '联系客服',
        message: '18618264599（王老师）',
        confirmButtonText:'拨打',
      }).then(() => {
          const number = '18618264599';
          window.HostApp.call(number)
      }).catch(() => {
        // on cancel
      });
    },
    async  openVip(){
      if(this.user && (this.is_vip === 1 || this.is_vip === 2)){
        Toast({
          message: '您已经是VIP会员了',
          duration: 1000
        })
        return;
      }
      if(isAndroid_Ios()=='android'){
          const res =await apiUtil.post(apiConst.becomevip);
          let result = res.orginite;
          if(result.code==7001){
            this.$router.push({path:'my/wallet'})
          }else if(result.code==200){
            let tag = this.user.jpush_status;
            window.HostApp.pushMsg(tag);
            this.$router.push({path:'/my'});
          }
      }else{
          //ios
          if(!this.user){
            this.$router.push('login');
          }else{
             window.HostApp.callAppVippay(this.vip_tag);
          }
          

      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.open-view {
  .banner-wrap{
    height: 334px;
    padding: 32px 30px;
    background-color: #26333C

    .banner{
      position relative;
      padding: 36px 62px;
      height: 100%;
      background:linear-gradient(194deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%);
      border-radius:18px;
      color: #fff;
      &.green{
        background:linear-gradient(211deg,rgba(180,236,81,1) 0%,rgba(66,147,33,1) 100%);
      }
      .title {
        font-size: 32px;
        margin-bottom: 16px;
      }
      .business-vip{
        font-size: 28px;
        line-height:40px;
        text-align: justify;
         text-indent:60px;
      }
      .sub-title {
        font-size: 28px;
        margin-bottom: 32px;
      }
      .text--sub{
        color: #fff;
      }
      .price-text {
        position absolute;
        bottom: 32px;
        right: 32px;
        font-size: 40px;
        font-weight: bold;
      }
    }
  }
  .info-wrap {
    padding: 37px;
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 18px;
    }
    .blank-wrap{
      height: 300px;
      margin-bottom: 17px;
      background-color: #fff;
    }
    .invite-img{
            display: block;
      width: 680px;

      height: 157px;
    }
    .right-img {
      display: block;
      margin: 0 auto 20px
      width: 680px;

    }
  }
  .footer{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    line-height: 100px;
    text-align: center;
    z-index: 999;
    .button {
      width: 700px;
      height: 88px;
      background:linear-gradient(270deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%);
      border-radius:44px;
      color: #fff;
      font-size: 32px;
      &.green{
        background:linear-gradient(270deg,rgba(180,236,81,1) 0%,rgba(66,147,33,1) 100%);
      }
    }
  }
}
</style>


